import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getXml = (state: RootState) => state.pages.editor.scene.xml;

const getSceneXml = createSelector([getXml], (xml) => xml);

export default getSceneXml;
